import {
  EnvelopeIcon,
  ChatBubbleBottomCenterTextIcon,
  ArrowTopRightOnSquareIcon,
  ClockIcon,
  FunnelIcon,
  ArrowsRightLeftIcon,
  BellIcon,
  ArrowPathIcon,
} from "@heroicons/react/24/outline";


const IS_DEV_MODE = window.location.hostname === "localhost";

const NODE_TYPE = {
  STAKEHOLDER: "stakeholder",
  ACTION: "action",
  TRIGGER: "trigger",
  DELAY: "delay",
  EMAIL: "email",
  SMS: "sms",
  PUSH_NOTIFICATION: "push_notification",
  WEBHOOK: "webhook",
  FILTER: "filter",
  BRANCH: "branch",
  AB_TEST: "ab_test",
};

const NODE_ACTION_TYPE = {
  LOGIC: "logic",
  ACTION: "action",
};

const NODE_TYPE_DATA = {
  [NODE_TYPE.TRIGGER]: {
    label: "Goal",
    description: "Goal of the workflow",
    icon: EnvelopeIcon,
    color: "bg-green-50",
    actionType: NODE_ACTION_TYPE.LOGIC,
  },
  [NODE_TYPE.DELAY]: {
    label: "Delay",
    description: "Delay the workflow",
    icon: ClockIcon,
    color: "bg-blue-50",
    actionType: NODE_ACTION_TYPE.LOGIC,
  },
  [NODE_TYPE.EMAIL]: {
    label: "Email",
    description: "Send an email",
    icon: EnvelopeIcon,
    color: "bg-yellow-50",
    actionType: NODE_ACTION_TYPE.ACTION,
  },
  [NODE_TYPE.SMS]: {
    label: "SMS",
    description: "Send an SMS",
    icon: ChatBubbleBottomCenterTextIcon,
    color: "bg-red-50",
    actionType: NODE_ACTION_TYPE.ACTION,
  },
  [NODE_TYPE.PUSH_NOTIFICATION]: {
    label: "Push Notification",
    description: "Send a push notification",
    icon: BellIcon,
    color: "bg-purple-50",
    actionType: NODE_ACTION_TYPE.ACTION,
  },
  [NODE_TYPE.WEBHOOK]: {
    label: "Webhook",
    description: "Send a webhook",
    icon: ArrowTopRightOnSquareIcon,
    color: "bg-orange-50",
    actionType: NODE_ACTION_TYPE.ACTION,
  },
  [NODE_TYPE.FILTER]: {
    label: "Filter",
    description: "Filter the workflow",
    icon: FunnelIcon,
    color: "bg-pink-50",
    actionType: NODE_ACTION_TYPE.LOGIC,
  },
  [NODE_TYPE.BRANCH]: {
    label: "Branch",
    description: "Branch the workflow",
    icon: ArrowsRightLeftIcon,
    color: "bg-gray-50",
    actionType: NODE_ACTION_TYPE.LOGIC,
  },
  [NODE_TYPE.AB_TEST]: {
    label: "AB Test",
    description: "AB Test the workflow",
    icon: ArrowPathIcon,
    color: "bg-green-50",
    actionType: NODE_ACTION_TYPE.LOGIC,
  },
};

let hardCodedSegments = {
  "segments": [
    {
      "id": 1,
      "title": "Administrators",
      "triggers": [
        {
          "id": 1,
          "title":
            "Pending club/event approvals not acted on after 3 days",
          "actions": [
            {
              "id": 101,
              "type": "email",
              "title": "Pending approvals — first reminder",
              "emailSubject":
                "Pending club and event approvals awaiting your review",
              "delay": 0,
              "sortIndex": 0,
            },
            {
              "id": 102,
              "type": "delay",
              "delay": 2,
              "sortIndex": 1,
            },
            {
              "id": 103,
              "type": "email",
              "title": "Pending approvals — second reminder",
              "emailSubject":
                "Second reminder: pending approvals on Rubric",
              "delay": 0,
              "sortIndex": 2,
            },
          ],
        },
        {
          "id": 12,
          "title":
            "Pending club/event approvals not acted on after 3 days",
          "actions": [
            {
              "id": 1011,
              "type": "email",
              "title": "Pending approvals — first reminder",
              "emailSubject":
                "Pending club and event approvals awaiting your review",
              "delay": 0,
              "sortIndex": 0,
            },
            {
              "id": 1021,
              "type": "delay",
              "delay": 2,
              "sortIndex": 1,
            },
            {
              "id": 1031,
              "type": "email",
              "title": "Pending approvals — second reminder",
              "emailSubject":
                "Second reminder: pending approvals on Rubric",
              "delay": 0,
              "sortIndex": 2,
            },
          ],
        },
        {
          "id": 13,
          "title":
            "Pending club/event approvals not acted on after 3 days",
          "actions": [
            {
              "id": 1012,
              "type": "email",
              "title": "Pending approvals — first reminder",
              "emailSubject":
                "Pending club and event approvals awaiting your review",
              "delay": 0,
              "sortIndex": 0,
            },
            {
              "id": 1022,
              "type": "delay",
              "delay": 2,
              "sortIndex": 1,
            },
            {
              "id": 1032,
              "type": "email",
              "title": "Pending approvals — second reminder",
              "emailSubject":
                "Second reminder: pending approvals on Rubric",
              "delay": 0,
              "sortIndex": 2,
            },
          ],
        },
      ],
    },
    {
      "id": 2,
      "title": "Club Executives",
      "triggers": [
        {
          "id": 2,
          "title": "Event submission pending edits after rejection",
          "actions": [
            {
              "id": 201,
              "type": "email",
              "title": "Your event needs edits",
              "emailSubject":
                "Action required: please update your event submission",
              "delay": 0,
              "sortIndex": 0,
            },
            {
              "id": 202,
              "type": "delay",
              "delay": 3,
              "sortIndex": 1,
            },
            {
              "id": 203,
              "type": "email",
              "title": "Event still pending edits",
              "emailSubject":
                "Reminder: your event is still awaiting updates",
              "delay": 0,
              "sortIndex": 2,
            },
          ],
        },
      ],
    },
  ],
};

export { NODE_TYPE, NODE_TYPE_DATA, NODE_ACTION_TYPE };
